/* Prices for visitors from abroad (19 Sep). The shop charges only in JOD and delivers only in Jordan, so this never
   changes what she pays: every JOD price keeps its JOD amount and gets an approximate "≈ SAR 142.80" beside it,
   and the bag says plainly that checkout is in JOD. Rates: live once a day (open.er-api.com) when the page may
   fetch it; otherwise only the currencies pegged to the dollar (fixed rates), so nothing shown is a guess. */
(function () {
  const USD = 1.41044;   // 1 JOD in USD: the dinar is pegged at 0.709 JOD per dollar
  const PEG = { JOD: 1, USD, SAR: USD * 3.75, AED: USD * 3.6725, QAR: USD * 3.64, BHD: USD * 0.376, OMR: USD * 0.3845 };
  const LIST = ['JOD', 'USD', 'SAR', 'AED', 'KWD', 'QAR', 'BHD', 'OMR', 'EUR', 'GBP', 'EGP', 'TRY'];
  const TZ = { 'Asia/Amman': 'JOD', 'Asia/Riyadh': 'SAR', 'Asia/Dubai': 'AED', 'Asia/Kuwait': 'KWD', 'Asia/Qatar': 'QAR', 'Asia/Bahrain': 'BHD',
    'Asia/Muscat': 'OMR', 'Europe/London': 'GBP', 'Africa/Cairo': 'EGP', 'Europe/Istanbul': 'TRY' };
  const get = (k) => { try { return localStorage.getItem(k); } catch (e) { return null; } };
  const set = (k, v) => { try { localStorage.setItem(k, v); } catch (e) { /* no storage */ } };
  let rates = { ...PEG };
  try { const c = JSON.parse(get('fomo2.fx') || 'null'); if (c && Date.now() - c.t < 12 * 3600e3) rates = { ...PEG, ...c.r }; } catch (e) { /* none cached */ }
  const guess = () => {
    let tz = ''; try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) { /* unknown */ }
    if (TZ[tz]) return TZ[tz];
    if (/^Europe\//.test(tz)) return 'EUR';
    if (/^America\//.test(tz)) return 'USD';
    return 'JOD';
  };
  let cur = get('fomo2.cur') || guess();
  const AR = () => window.FOMO_LANG === 'ar';
  const on = () => cur !== 'JOD' && rates[cur];
  const fmt = (n) => { const v = n * rates[cur]; return `≈ ${cur} ${v >= 1000 ? Math.round(v).toLocaleString('en') : v.toFixed(2)}`; };
  const PRICE = /(\d{1,5}(?:\.\d{3})?) (?:JOD|د\.أ)|(?:JOD) (\d{1,5}(?:\.\d{3})?)/;

  function mark(root) {
    if (!on() || !root || root.nodeType !== 1) return;
    root.querySelectorAll('.num, .pc__price, .price').forEach((el) => {
      if (el.querySelector('.fx') || el.closest('.fx, pre, s')) return;
      const m = el.textContent.match(PRICE); if (!m) return;
      const n = parseFloat(m[1] || m[2]); if (!(n > 0)) return;
      const s = document.createElement('span'); s.className = 'fx'; s.textContent = fmt(n); el.appendChild(s);
    });
    const foot = document.getElementById('bagFoot');
    if (foot && foot.children.length && !foot.querySelector('.fxnote')) {
      const p = document.createElement('p'); p.className = 'fxnote';
      p.textContent = AR() ? 'تدفعين بالدينار الأردني عند إتمام الطلب · نوصّل داخل الأردن' : 'You pay in JOD at checkout · we deliver in Jordan';
      foot.appendChild(p);
    }
  }
  function picker() {
    const opts = LIST.filter((c) => rates[c]).map((c) => `<option value="${c}" ${c === cur ? 'selected' : ''}>${c}</option>`).join('');
    // 20 Sep, his call: no selector in the top bar; the currency follows the visitor's location (time zone) and the footer keeps a quiet override
    document.querySelectorAll('[data-slot="fx-head"]').forEach((el) => {
      el.innerHTML = `<select data-fx aria-label="${AR() ? 'العملة' : 'Currency'}">${opts}</select>`;
    });
    document.querySelectorAll('[data-slot="fx"]').forEach((el) => {
      el.innerHTML = `<label class="fxpick"><span>${AR() ? 'العملة' : 'Currency'}</span><select data-fx aria-label="${AR() ? 'العملة' : 'Currency'}">${opts}</select></label>`;
    });
  }
  document.addEventListener('change', (e) => {
    if (!e.target.matches || !e.target.matches('[data-fx]')) return;
    cur = e.target.value; set('fomo2.cur', cur);
    document.querySelectorAll('.fx, .fxnote').forEach((x) => x.remove()); picker(); mark(document.body);
  });
  const start = () => {
    picker(); mark(document.body);
    new MutationObserver((ms) => ms.forEach((m) => m.addedNodes.forEach((n) => { if (n.nodeType === 1 && !n.classList.contains('fx') && !n.classList.contains('fxnote')) mark(n.parentElement || n); }))).observe(document.body, { childList: true, subtree: true });
    // live rates once a day where the page may fetch them (the shop); the pegged ones never need it
    if (!window.A_ || (get('fomo2.fx') && rates.EUR)) return;
    fetch('https://open.er-api.com/v6/latest/JOD').then((r) => r.json()).then((d) => {
      if (!d || !d.rates) return;
      const r = {}; LIST.forEach((c) => { if (d.rates[c]) r[c] = d.rates[c]; });
      set('fomo2.fx', JSON.stringify({ t: Date.now(), r })); rates = { ...PEG, ...r };
      picker(); document.querySelectorAll('.fx').forEach((x) => x.remove()); mark(document.body);
    }).catch(() => { /* pegged rates only */ });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
}());
